<template>
  <CHeader fixed with-subheader light>
    <CToggler in-header class="ml-3 d-lg-none" @click="$store.commit('toggleSidebarMobile')" />
    <CToggler in-header class="ml-3 d-md-down-none" @click="$store.commit('toggleSidebarDesktop')" />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <CIcon  :src="origin_url+'/img/quiz_pro_logo.png'" height="48" alt="Logo" />
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none">
      <CHeaderNavItem class="px-3" to="/dashboard">Admin Dashboard</CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav class="ml-auto mr-4">
        <TheHeaderDropdownAccnt />
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0" />
    </CSubheader>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";

export default {
  name: "TheHeader",
  data() {
    return {
      origin_url: window.location.origin
    }
  },
  components: {
    TheHeaderDropdownAccnt
  }
};
</script>
